import { render, staticRenderFns } from "./part_send_order_dialog.vue?vue&type=template&id=48cdc9ae"
import script from "./part_send_order_dialog.vue?vue&type=script&lang=js"
export * from "./part_send_order_dialog.vue?vue&type=script&lang=js"
import style0 from "./part_send_order_dialog.vue?vue&type=style&index=0&id=48cdc9ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports